(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-video-carousal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  if (window.Swiper) {
    new Swiper('.video-carousel-swiper', {
      slidesPerView: 1.4,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 }
      }
    });
  }
  const modal = document.getElementById('video-modal');
const player = document.getElementById('video-modal-player');
const closeBtn = document.querySelector('.video-modal-close');
const nextBtn = document.getElementById('video-next');
const prevBtn = document.getElementById('video-prev');

let currentIndex = 0;
const slides = document.querySelectorAll('.video-carousel-swiper .swiper-slide');

function showModal(index) {
  const videoTag = slides[index].querySelector('video');
  if (!videoTag) return;

  const source = videoTag.querySelector('source')?.src || videoTag.src;
  player.src = source;
  modal.classList.remove('hidden');
  currentIndex = index;

  // Product info
    const slide = slides[index];
    const productImg = slide.querySelector('.video-card-product-image')?.src;
    const productTitle = slide.querySelector('.video-card-product-title')?.textContent;
    const productPrice = slide.querySelector('.video-card-product-price')?.textContent;
    const productCompare = slide.querySelector('.video-card-product-compare')?.textContent;
    const productUrl = slide.querySelector('.video-card-product-image')?.closest('div')?.dataset.productUrl;
    const productInfoHTML = `
      <a href="${productUrl || '#'}">
      ${productImg ? `<img src="${productImg}" alt="${productTitle}" />` : ''}
      <div class="video-modal-product-info-title">${productTitle || ''}</div>
      <div class="video-modal-product-info-prices">
        ${productPrice ? `<span class="video-modal-product-info-price">${productPrice}</span>` : ''}
        ${productCompare ? `<span class="video-modal-product-info-compare">${productCompare}</span>` : ''}
      </div>
      <span class="video-modal-product-shopnow"><span>Shop now</span><span> > </span></span>
      </a>
    `;
    
    document.getElementById('video-modal-product-info').innerHTML = productInfoHTML;

}

function closeModal() {
  modal.classList.add('hidden');
  player.pause();
  player.src = '';
}

function showNext() {
  const nextIndex = (currentIndex + 1) % slides.length;
  showModal(nextIndex);
}

function showPrev() {
  const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
  showModal(prevIndex);
}

slides.forEach((slide, index) => {
  slide.addEventListener('click', () => showModal(index));
});

closeBtn.addEventListener('click', closeModal);
nextBtn.addEventListener('click', showNext);
prevBtn.addEventListener('click', showPrev);

document.querySelector('.video-modal-overlay').addEventListener('click', closeModal);
const soundToggle = document.getElementById('video-sound-toggle');

soundToggle.addEventListener('click', () => {
  player.muted = !player.muted;
  soundToggle.textContent = player.muted ? '🔇' : '🔊';
});

});

  } catch(e) { console.error(e); }
})();
})();
